import { THEMES, useTheme } from '@/store/useTheme';

import styles from './ThemeSwitcher.module.css';

/** Controle segmentado de tema (Claro / Escuro / Black) no header. */
export function ThemeSwitcher() {
  const theme = useTheme((s) => s.theme);
  const setTheme = useTheme((s) => s.setTheme);

  return (
    <div className={styles.root} role="group" aria-label="Tema da interface">
      {THEMES.map((t) => (
        <button
          key={t.value}
          type="button"
          className={`${styles.seg} ${theme === t.value ? styles.segActive : ''}`}
          aria-pressed={theme === t.value}
          onClick={() => setTheme(t.value)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
